namespace B2B.UI {
    export class Transition {
        private static _transitionEvents: any;

        public static get supports() : boolean {
            Transition.ensureInitialized();
            return Object.keys(Transition._transitionEvents).length > 0;
        }

        private static ensureInitialized(){
            if(this._transitionEvents){
                return;
            }
            this._transitionEvents = {};

            let el = document.createElement('transitionTest')

            let transEndEventNames = {
                'WebkitTransition' : 'webkitTransitionEnd',
                'MozTransition'    : 'transitionend',
                'OTransition'      : 'oTransitionEnd otransitionend',
                'transition'       : 'transitionend',
                'MSTransitionEnd'  : 'msTransitionEnd',
                'msTransitionEnd'  : 'msTransitionEnd'
            }

            for (let name in transEndEventNames) {
                if (el.style[name] !== undefined) {
                    Transition._transitionEvents = { end: transEndEventNames[name] };
                    return;
                }
            }
        }

        public static get endEventName():string {
            Transition.ensureInitialized();

            return Transition._transitionEvents["end"];
        }
    }
}